import { createSlice } from "@reduxjs/toolkit";

const loadDemandedSlice = createSlice({
  name: "loadDemanded",
  initialState: {
    loadDemanded: null,
    isFetching: false,
    error: false,
    errorMessage: null,
  },
  reducers: {
    loadDemandedStart: (state) => {
      state.isFetching = true;
      state.error = false;
      state.errorMessage = null;
    },
    loadDemandedSuccess: (state, action) => {
      state.isFetching = false;
      state.loadDemanded = action.payload;
      state.error = false;
      state.errorMessage = null;
    },
    loadDemandedFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.errorMessage = action.payload || "Error al obtener carga demandada";
    },
    logoutLoadDemanded: (state) => {
      state.loadDemanded = null;
      state.isFetching = false;
      state.error = false;
      state.errorMessage = null;
    },
  },
});

export const {
  loadDemandedStart,
  loadDemandedSuccess,
  loadDemandedFailure,
  logoutLoadDemanded,
} = loadDemandedSlice.actions;

export default loadDemandedSlice.reducer;